import React from 'react';
import './Page.css';
import php from './assets/php.jpg';
import python from './assets/python.jpg';
import c from './assets/c.png';
import cplus from './assets/c++.png';

const Home=()=>{
        return(
            <>
            <div className='pagecontainer'>
               <h1 className='heading'>OUR COURSES</h1>
                <div className='flexrow'>
                     <div className='itembox'>
                        <img src={php} alt='php'  className='image'/>
                        <p>PHP</p>
                     </div>

                      <div className='itembox'>
                         <img src={python} alt='python' className='image'/>
                         <p>PYTHON</p>
                      </div>

                      <div className='itembox'>
                         <img src={c} alt='c'  className='image'/>
                        <p>C Languages</p>
                      </div>

                      <div className='itembox'>
                         <img src={cplus} alt='cplus' className='image'/>
                         <p>C++ Languages</p>
                      </div>
                </div>
           </div>
            </>

        );
};

export default Home;